import type { ReadingMode } from '@lilith-arcana-os/domain';

import type { SymbolicPhase } from '../types';

export interface SalienceProfile {
  base: number;
  phaseBonus?: number;
  modeBonus?: Partial<Record<ReadingMode, number>>;
}

const PHASE_BASELINE: Record<SymbolicPhase, number> = {
  normalize: 0,
  facts: 10,
  position: 140,
  'local-card': 130,
  pairwise: 110,
  triads: 100,
  'global-balance': 120,
  numerology: 90,
  decan: 70,
  kabbalah: 85,
  qliphoth: 85,
  'mode-overlay': 150,
  'focus-overlay': 145,
  'memory-overlay': 80,
  narrative: 60,
  finalize: 20,
};

export const SALIENCE_DEFAULTS: Record<SymbolicPhase, SalienceProfile> = Object.fromEntries(
  Object.entries(PHASE_BASELINE).map(([phase, base]) => [phase, { base }]),
) as Record<SymbolicPhase, SalienceProfile>;

export const computeSalience = (
  phase: SymbolicPhase,
  profile?: SalienceProfile,
  mode?: ReadingMode,
): number => {
  const baseline = PHASE_BASELINE[phase];
  const modeBonus =
    mode && profile?.modeBonus && profile.modeBonus[mode] ? profile.modeBonus[mode] ?? 0 : 0;

  return baseline + (profile?.base ?? 0) + (profile?.phaseBonus ?? 0) + modeBonus;
};
